import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { ProjetoFonteRecurso } from '../models/projeto-fonte-recurso.model';

@Injectable()
export class ProjetoFonteRecursoService extends BaseService<ProjetoFonteRecurso> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/projeto-fonte-recurso';
  }
}
